import PostCard from 'hb-react/frontoffice/apps/News/components/PostCard';
import Carousel from 'hb-react/shared/components/Carousel/';

/**
 * @deprecated - only used on old HAML Public Homepage
 */
const NewsCarousel = ({ items, images = [] }) => {
  if (!items) {
    return null;
  }

  const newsList = items.map((news) => ({
    ...news,
    categories: news.categories || [],
    customClassNames: 'one-whole bloc-item-container',
    cover_picture:
      news.cover_picture ||
      images?.find((image) => image.id === news.id)?.cover_picture_url,
  }));

  return <Carousel items={newsList} ElementComponent={PostCard} />;
};

export default NewsCarousel;
